<script lang="ts" setup>
import type {
  FilteredPremiumNumberType,
  PremiumCategoryView,
  PremiumNumberType,
} from "@/struct/PremiumPhoneStruct";
import {
  NumbersMapStruct,
  PremiumCategoryStruct,
} from "@/struct/PremiumStruct";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { t } = useI18n();

const props = defineProps<{
  activeNumber?: number;
  formatPhone: (phone: string) => string;
  numbers: PremiumNumberType[];
  isFilled: boolean;
  searchValue: string;

  title: string;
  isLoadingListing: false;
}>();

const emit = defineEmits<{
  (e: "select", number: number, price: string | number, type: string): void;
  (e: "show-more"): void;
}>();

const getHighlightedPhone = (phoneId: number | string): string => {
  const rawPhone = phoneId.toString();
  const formatted = props.formatPhone(rawPhone); // Сначала делаем стандартный красивый формат (+7 xxx xxx xx xx)
  const query = props.searchValue.trim();

  if (!query) return formatted;

  const searchPattern = query.split("").join("\\s*");
  const regex = new RegExp(searchPattern, "gi");

  return formatted.replace(
    regex,
    (match) => `<span class="highlight">${match}</span>`
  );
};
</script>

<template>
  <div class="premium-phones--body-category">
    <div class="premium-phones--body-category_title">
      <p class="h2">{{ title }}</p>
    </div>
    <div class="premium-phones--body-category_list">
      <div
        v-for="num in numbers"
        :key="num.id"
        class="premium-phones--body-category_item"
        :class="{ active: activeNumber === num.id }"
        @click="
          emit(
            'select',
            num.id,
            Number(num.activationPrice),
            num.msisdnType.name
          )
        "
      >
        <span
          class="caption-normal"
          v-html="getHighlightedPhone(num.id)"
        ></span>
        <div class="price">
          <p class="caption-medium">{{ Math.round(num.activationPrice) }} ₽</p>
        </div>
      </div>
    </div>
    <div
      v-if="numbers?.length && !isFilled"
      class="premium-phones--body-category_more"
    >
      <button
        class="caption-small color-secondary uppercase bold"
        @click="emit('show-more')"
      >
        {{ t("premium.showMore") }}
      </button>
    </div>
    <div
      v-if="!numbers?.length && !isLoadingListing"
      class="premium-phones--body-category_empty"
    >
      <p class="caption-medium">{{ t("premium.notFound") }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/premium";
</style>
